import { render, staticRenderFns } from "./StockGeneral.vue?vue&type=template&id=0dbcf090&"
import script from "./StockGeneral.vue?vue&type=script&lang=js&"
export * from "./StockGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports